import React from 'react';
import { Button } from '@pushpay/button';
import { ExternalLinkIcon } from '@pushpay/iconography';
import { Link } from '@pushpay/link';
import { clsx, createUseStyles } from '@pushpay/styles';
import { AppStudioTheme } from '@pushpay/theming';
const useStyles = createUseStyles(theme => ({
  base: {
    backgroundColor: theme.colors['palette-purple-light-400'],
    border: `solid 1px ${AppStudioTheme.colors['product-color-dark-100']}`,
    borderRadius: theme.SHAPE.ROUNDED_CORNERS,
    color: AppStudioTheme.colors['product-color-dark-100'],
    display: 'inline-block',
    paddingLeft: theme.SPACING.SMALL_ICON_SIZE,
    paddingRight: theme.SPACING.SMALL_ICON_SIZE
  },
  button: {
    paddingBottom: theme.SPACING.XXSMALL,
    paddingTop: theme.SPACING.XXSMALL
  },
  iconWithLabel: {
    marginRight: 4
  },
  label: {
    lineHeight: 1.25
  },
  labelWrap: {
    paddingBottom: theme.SPACING.XXSMALL,
    paddingTop: theme.SPACING.XXSMALL
  },
  link: {
    paddingBottom: '2px',
    paddingTop: '2px'
  }
}));
export const BetaTag = ({
  classes: classesProp,
  href = undefined,
  label,
  onClick = undefined
}) => {
  const classes = useStyles(classesProp);
  const content = /*#__PURE__*/React.createElement(React.Fragment, null, (href || onClick) && /*#__PURE__*/React.createElement(ExternalLinkIcon, {
    className: classes.iconWithLabel,
    displaySize: "small"
  }), /*#__PURE__*/React.createElement("span", {
    className: classes.label
  }, label));

  if (onClick) {
    return /*#__PURE__*/React.createElement(Button, {
      className: clsx(classes.base, classes.button),
      onClick: onClick,
      type: "button"
    }, content);
  }

  if (href) {
    return /*#__PURE__*/React.createElement(Link, {
      className: clsx(classes.base, classes.link),
      href: href,
      target: "_blank"
    }, content);
  }

  return /*#__PURE__*/React.createElement("div", {
    className: clsx(classes.base, classes.labelWrap)
  }, content);
};